import axiosClient from "../api/axiosConfig";
import {
  requestStatuses,
  validateRequest,
  requestConfig,
} from "../api/requestHelper";
import { Dispatch, Action } from "redux";

export type requestTypes = {
  request?: requestConfig;
  types?: string[] | undefined;
  meta?: {};
};

export type requestMiddlewareAction = Action & requestTypes;

const axiosMiddleware = ({ dispatch }) => (next: Dispatch) => (
  action: requestMiddlewareAction
) => {
  const actReq = action.request;
  if (!actReq) {
    return next(action);
  }
  const statuses = requestStatuses(action.type, action.types);
  validateRequest(actReq);

  next({ meta: action.meta, type: statuses.start }); //start request

  return new Promise((resolve, reject) => {
    axiosClient()
      .request(actReq)
      .then(
        (response: any) => {
          const successAction = {
            meta: action.meta,
            type: statuses.success,
            payload: response.data,
            resHeaders: response.headers,
          };

          resolve(successAction);

          return next(successAction); //success request
        },
        (error: any) => {
          const errorAction = {
            meta: action.meta,
            type: statuses.error,
            error: error.response,
          };
          if (error?.response?.status === 401) {
            //logout
          }
          if (actReq?.notifyMessage?.error) {
            // responce error message
          }
          reject(errorAction);

          return next(errorAction); //error request
        }
      );
  });
};

export default axiosMiddleware;
